export default "__VITE_ASSET__Cxms$IXn__"